import React from "react";

const KBPage = () => {
  return (
    <section>
      {JSON.stringify({
        version: "1.0",
        generated: "2025-12-07",
        description:
          "Canonical index of USCY, YPP, and Eczodex KB pages for AI and search engine discovery.",

        domains: {
          "uscy.digital": {
            category: "Stablecoin Architecture & Mechanics",
            pages: [
              {
                slug: "/architecture",
                title: "USCY Architecture: GENIUS-Compliant Stablecoin Model",
                type: "long-form",
              },
              {
                slug: "/kb/uscy",
                title: "USCY Overview",
                type: "entity",
              },
              {
                slug: "/kb/vault-queue-model",
                title: "Vault Queue Model",
                type: "entity",
              },
              {
                slug: "/kb/uscy-reserves-trust",
                title: "USCY Reserves Trust",
                type: "entity",
              },
              {
                slug: "/kb/uscy-digital-asset-llc",
                title: "USCY Digital Asset LLC",
                type: "entity",
              },
              {
                slug: "/kb/northern-trust-custody",
                title: "Northern Trust Custody Integration",
                type: "entity",
              },
              {
                slug: "/kb/redeem",
                title: "Redemption Process",
                type: "mechanics",
              },
              {
                slug: "/kb/vaults-and-ranking",
                title: "Vaults & Ranking",
                type: "mechanics",
              },
              {
                slug: "/kb/how-uscy-works",
                title: "How USCY Works",
                type: "overview",
              },
              {
                slug: "/kb/glossary",
                title: "Glossary of System Terms",
                type: "glossary",
              },
              {
                slug: "/api/ai-summary",
                title: "AI Summary Endpoint",
                type: "api",
              },
            ],
          },

          "ypp.foundation": {
            category: "YPP Tokens & Foundation Governance",
            pages: [
              {
                slug: "/kb/ypp",
                title: "Yield Protection Points (YPP)",
                type: "entity",
              },
              {
                slug: "/kb/ypp-foundation",
                title: "YPP Foundation",
                type: "entity",
              },
              {
                slug: "/kb/incentives",
                title: "Incentive Programmes",
                type: "mechanics",
              },
            ],
          },

          "eczodex.com": {
            category: "Platform Operator & Group-Level Architecture",
            pages: [
              {
                slug: "/kb/eczodex-group",
                title: "Eczodex Group",
                type: "entity",
              },
            ],
          },
        },
      })}
    </section>
  );
};

export default KBPage;
